import { render, staticRenderFns } from "./DetailByEmployee.vue?vue&type=template&id=e21990c0"
import script from "./DetailByEmployee.vue?vue&type=script&lang=js"
export * from "./DetailByEmployee.vue?vue&type=script&lang=js"
import style0 from "./DetailByEmployee.vue?vue&type=style&index=0&id=e21990c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports